module.exports = __webpack_public_path__ + "img/etoile.f7664eea.png";